export default function Button({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon = null,
  type = 'button',
  fullWidth = false,
  style = {},
}) {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    border: 'none',
    borderRadius: 'var(--radius-md)',
    fontFamily: 'var(--font-primary)',
    fontWeight: 'var(--font-weight-normal)',
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    opacity: disabled || loading ? 0.5 : 1,
    transition: 'opacity 0.15s, background 0.15s',
    whiteSpace: 'nowrap',
    width: fullWidth ? '100%' : 'auto',
  };

  const sizes = {
    sm: { fontSize: 11, padding: '5px 10px', height: 28 },
    md: { fontSize: 13, padding: '7px 14px', height: 34 },
    lg: { fontSize: 14, padding: '10px 20px', height: 40 },
  };

  const variants = {
    primary: {
      background: 'var(--color-brand)',
      color: '#fff',
      border: 'none',
    },
    secondary: {
      background: 'transparent',
      color: 'var(--color-text-secondary)',
      border: '0.5px solid var(--color-border-medium)',
    },
    danger: {
      background: 'var(--color-danger)',
      color: '#fff',
      border: 'none',
    },
    success: {
      background: 'var(--color-success)',
      color: '#fff',
      border: 'none',
    },
    ghost: {
      background: 'transparent',
      color: 'var(--color-text-secondary)',
      border: 'none',
    },
    'danger-outline': {
      background: 'transparent',
      color: 'var(--color-danger)',
      border: '0.5px solid var(--color-danger)',
    },
    'success-outline': {
      background: 'transparent',
      color: 'var(--color-success)',
      border: '0.5px solid var(--color-success)',
    },
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        ...base,
        ...sizes[size],
        ...variants[variant],
        ...style,
      }}
    >
      {loading ? (
        <span style={{ fontSize: 11 }}>Loading...</span>
      ) : (
        <>
          {icon && icon}
          {children}
        </>
      )}
    </button>
  );
}